const dropdowns = require("./staticDropdowns.json");

const actions = {};

const mutations = {};

const getters = {
  getList(state) {
    return state.dropdowns;
  },
  getOptionList: state => type => {
    return state.dropdowns[type];
  },
};

const state = {
  dropdowns,
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
